import React from 'react';
import { Button } from 'react-bootstrap';
import { BsCardHeading, BsPrinter } from 'react-icons/bs';

const ActionButtons = ({ 
  student,
  onView,
  onEdit,
  onDelete,
  onReminder,
  onFeeManagement,
  onPrintCard,
  onPrintSlip
}) => {
  return (
    <div className="d-flex flex-wrap gap-2 action-buttons">
      <Button size="sm" variant="info" onClick={() => onView(student)}>
        View
      </Button>
      <Button size="sm" variant="primary" onClick={() => onEdit(student)}>
        Edit
      </Button>
      <Button size="sm" variant="warning" onClick={() => onFeeManagement(student)}>
        Fees
      </Button>
      <Button size="sm" variant="danger" onClick={() => onDelete(student.id)}>
        Delete
      </Button>
      <div className="dropdown">
        <Button size="sm" variant="secondary" className="dropdown-toggle" data-bs-toggle="dropdown">
          More
        </Button>
        <ul className="dropdown-menu">
          <li>
            <Button size="sm" variant="link" className="dropdown-item" onClick={() => onPrintCard(student)}>
              <BsCardHeading className="me-2" />
              Print ID Card
            </Button>
          </li>
          <li>
            <Button size="sm" variant="link" className="dropdown-item" onClick={() => onPrintSlip(student)}>
              <BsPrinter className="me-2" />
              Print Registration
            </Button>
          </li>
          <li>
            <Button size="sm" variant="link" className="dropdown-item" onClick={() => onReminder(student)}>
              Send Reminder
            </Button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ActionButtons;
